import { render, staticRenderFns } from "./productCenter.vue?vue&type=template&id=7a9a2202&scoped=true&"
import script from "./productCenter.vue?vue&type=script&lang=js&"
export * from "./productCenter.vue?vue&type=script&lang=js&"
import style0 from "./productCenter.vue?vue&type=style&index=0&id=7a9a2202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9a2202",
  null
  
)

export default component.exports